// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuetify from "vuetify";
import axios from "axios";
import API_URL from "@/constants/API_URL";
import "vuetify/dist/vuetify.min.css";
import '@/assets/styles/main.scss';
import "material-design-icons-iconfont/dist/material-design-icons.css";
import VueGeolocation from "vue-browser-geolocation";
import "@mdi/font/css/materialdesignicons.css";
import clampy from "@clampy-js/vue-clampy";

import tinymce from "vue-tinymce-editor";
import App from "./App";
import router from "./router";
import store from "./store";

import "./filters/formatDate";
import BootstrapVue from "bootstrap-vue";

// import * as Sentry from "@sentry/vue";
Vue.use(BootstrapVue);
Vue.component("tinymce", tinymce);
Vue.use(clampy);
Vue.use(VueGeolocation);
Vue.use(Vuetify, {
  theme: {
    primary: "#666666",
    secondary: "#FAFAFA",
    accent: "#308afb",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#ffd200",
    docgo: "#4185f4"
  },
  options: {
    themeVariations: ["primary", "secondary", "accent"]
  },
  iconfont: "mdi"
});

Vue.config.productionTip = false;

axios.defaults.baseURL = API_URL();
async function getActiveUnit() {
  let activeUnit = store.state.me.selectedAdministrativeUnit || localStorage.getItem("selectedAdministrativeUnit");

  if (!activeUnit) {
    const stateUser = store.state.me.user;

    if (stateUser && stateUser.administrative_unit && stateUser.administrative_unit.id) {
      activeUnit = stateUser.administrative_unit.id;
    } else if (localStorage.getItem("user")) {
      const localStorageUser = localStorage.getItem("user");
      try {
        const parsedUser = JSON.parse(localStorageUser);
        if (parsedUser && parsedUser.administrative_unit && parsedUser.administrative_unit.id) {
          activeUnit = parsedUser.administrative_unit.id;
        }
      } catch (e) {
        console.error("Erro ao analisar o usuário do localStorage:", e);
      }
    }
  }

  return activeUnit;
}

axios.interceptors.request.use(async (config) => {
  const activeUnit = await getActiveUnit();

  if (activeUnit) {
    config.headers["X-Selected-Administrative-Unit"] = activeUnit;
  } else {
    console.warn("Nenhuma unidade administrativa ativa encontrada.");
  }

  return config;
});


axios.interceptors.response.use(
  response => response,
  error => {
    if (error && error.response && error.response.status === 401) {
      localStorage.clear();
      router.push({name: "FormSignin"});
    }
    return Promise.reject(error);
  }
);

// Sentry.init({
//   Vue,
//   dsn: "https://1683e1a3470ff66ef16e749951fb897b@o492405.ingest.us.sentry.io/4507788297240576",
//
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for tracing.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
//
//   // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/api\.marechal\.docgo\.com\.br/],
//
//   // Capture Replay for 10% of all sessions,
//   // plus for 100% of sessions with an error
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
// });

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {App},
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js